import Vue from 'vue'
import NastCore from 'nast'
import settings from './_config'
import libs from './_libs'
import ui from './_ui'
import { FaceID } from '@renova/faceid-capacitor'

Vue.use(ui)
NastCore.createApp(settings, libs)

async function bootstrap() {
    try {
        await FaceID.init({
            antiSpoofing: false,
            opencv: true,
            challenge: false,
            recognitionThreshold: 0.75,
            livenessThreshold: 0.99,
            minDetectionConfidence: 0.5,
            maxFps: 5,
            useGpu: false,
        })

        console.log('FaceID initialized')
    } catch (e) {
        console.error('FaceID init error', e)
    }


}

bootstrap()
